import { withCustomStyles } from 'src/hoc/withCustomStyles';
import { PickerLoadingContent } from '../../picker-loading-content/PickerLoadingContent';
import { styles } from './PickerComputerLoadingContent.styles';
import { PickerLoadingContentProps } from '../../picker-loading-content/PickerLoadingContent.types';

export const PickerComputerLoadingContent = withCustomStyles<{}, PickerLoadingContentProps['customStyles']>(
  PickerLoadingContent,
  styles,
);
